import { styled } from '@mui/system';
import { GetServerSidePropsContext, NextPage } from 'next';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import AppBottomNavigation from '@/containers/AppBottomNavigation';
import Banner from '../../components/Banner';
// import Promotion from '../containers/Promotion';
import { resetFilter } from '../../slices/filterFlight/filterFlightSlice';
import { resetSortingFlight } from '../../slices/sortingFlight/sortingFlightSlice';
import HeaderTabs from '@/components/HeaderTabs';
import { loadFallbackPoints } from '@/slices/area/slices/searchFlightFormSlice';
import { checkDate, setCalendarType } from '@/slices/calendar/calendarSlice';
import { resetSelectedBaggage } from '@/slices/baggage/slices/baggageSlice';
import HomepageMetaHeader from './header';
import BannerDiscount from '@/components/BannerDiscount';
import { useRouter } from 'next/router';
import { TransportationEnum } from '@/utils/constants';
import { resetFilter as resetBusFilter } from '@/slices/bus/filterBusRoute/filterBusRouteSlice';
import { resetSortingBusRoute } from '@/slices/bus/sortingBusRoute/sortingBusRouteSlice';
import { useAppSelector } from '@/utils/hook';
import { resetGlobalAll } from '@/slices/global/globalSlice';
import { useCheckIsMobile } from '@/utils/hooks/use-check-is-mobile';
import dynamic from 'next/dynamic';
import { addImagesPromotion } from '@/slices/strapi/slices/strapiSlice';
import { GoyoloFlexiEntityResponse } from '@/slices/goyoloSeo/sliceType';
import { store } from '@/utils/store';
import { queryFareConfig } from '@/utils/queryFareConfig';
import { addFareConfig } from '@/slices/fareRule/slices/fareRuleSlice';

const FlightDesktop = dynamic(() => import('./desktop'));

const StyledWrapper = styled('div')({
  position: 'relative',
});

const Flight: NextPage = (props: any = {}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const currentTab = useAppSelector((state) => state.headerTabs);
  const { imagePromotion, fareConfig } = props;

  useEffect(() => {
    dispatch(loadFallbackPoints());
    dispatch(resetFilter());
    dispatch(resetSortingFlight());
    dispatch(resetSelectedBaggage());
    dispatch(resetBusFilter());
    dispatch(resetSortingBusRoute());
    dispatch(checkDate());
    dispatch(resetGlobalAll());
    if (fareConfig) {
      dispatch(addFareConfig(fareConfig));
    }
    if (router.asPath.includes('/flight')) {
      dispatch(setCalendarType({ calendarType: TransportationEnum.FLIGHT }));
    }
    if (imagePromotion) {
      dispatch(addImagesPromotion(imagePromotion));
    }
  }, []);

  const isMobile = useCheckIsMobile();
  if (!isMobile) {
    return <FlightDesktop />;
  }

  return (
    <>
      <HomepageMetaHeader />
      <Banner />
      <StyledWrapper>
        <HeaderTabs onClickTab={(newTab: string) => {
          dispatch(setCalendarType({ calendarType: newTab as any }));
          dispatch(checkDate());
        }}
        />
      </StyledWrapper>
      <BannerDiscount
        sx={{ padding: '0 16px' }}
        vehicleType={currentTab === 0 ? 'flight' : 'bus'}
      />
      <AppBottomNavigation />
    </>
  );
};
export async function getServerSideProps(context: GetServerSidePropsContext) {
  const goyoloSeoHeaders = {
    Authorization: `Bearer ${process.env.VCMS_TOKEN}`,
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  let imagePromotion;
  const fareConfig = await queryFareConfig();
  try {
    const goyoloSeoFlexiData = `${process.env.VCMS_BASE_URL}/api/flexi-entities?filters[slug][$eq]=banner-discount&populate=deep`;
    const goyoloFlexiArray = await fetch(goyoloSeoFlexiData, { headers: goyoloSeoHeaders }).then((rps) => rps.json()).then((rps) => rps.data) as GoyoloFlexiEntityResponse[];
    imagePromotion = goyoloFlexiArray?.[0]?.attributes?.jsonAttributes?.[0]?.value;
  } catch (err) {
    console.log(err);
  }
  return {
    props: {
      imagePromotion: imagePromotion || null,
      fareConfig,
    },
  };
}

export default Flight;
